module.exports = __webpack_public_path__ + "static/wash_sec2_obj2@2x-8949fa8765b14760186ec89ac88e102f.png";